module.exports = __webpack_public_path__ + "static/media/UniversLTStd-Light.61d7c903.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/UniversLTStd-Light.woff2
// module id = 77
// module chunks = 0